import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchGameTypes = args => {
    return doDefaultFetch(`/site/api/gameType`, args);
};

//gameType?cayenneExp=id=2%20or%20id=3
//gameType?cayenneExp=id%20in%20(2,3)
const fetchRegularPlayoffGameTypes = args => {
    return doDefaultFetch(
        `/site/api/gameType` +
        `?cayenneExp=id = 2 or id = 3`,
        args
    );
};

const generateGameTypeSelectOptions = gameTypes => {
    return gameTypes.map(gameType => {
        gameType.value = gameType.id;
        gameType.label = gameType.description;
        return gameType;
    });
};

export default {
    fetchGameTypes,
    fetchRegularPlayoffGameTypes,
    generateGameTypeSelectOptions
};
